(function($) {

$(function() {
    $('.ajax').ajax();
    $('.dragdrop').dragdrop();
    $('.navigation').navigation();
    $('.tabs').tabs();

    $(document).bind('ajax.insert', function() {
        init();
    });

    init();
});

function init() {
    $(document).tooltip({
        'content': function() {
            // support: IE<9, Opera in jQuery <1.7
            // .text() can't accept undefined, so coerce to a string
            var title = $( this ).attr( "title" ) || "";
            // Escape title, since we're going from an attribute to raw HTML
            return $( "<a>" ).text( title ).html().replace('\n', '<br>');
        },
        'position': {
            'my': 'center top',
            'at': 'center bottom+10px',
            'collision': 'flipfit',
            'using': function(pos, ui) {
                if (pos.left + ui.element.width >= $(window).width()) {
                    pos.left -= 1;
                }
                $(this).css(pos);
            }
        }
    });

    if ($(window).width() < 480) {
            if($("div").hasClass("horizontal-divider")){
                $(".horizontal-divider").parent().css({display: "none"});
            }
    }

    $('.popup').popup();

    $('select:not(.no-chosen)').chosen({
        'search_contains': true,
        'width': '100%'
    });

    $('.type-date').datetime({
        'mode': 'date'
    });

    $('.type-week').datetime({
        'mode': 'week'
    });

    $('.type-datetime').datetime({
        'mode': 'datetime'
    });

    $('.type-time').timepicker({
        step: 15,
        scrollDefault: '09:00',
        maxTime: '11:59pm',
    });

    $('a[data-confirm]').confirm({
        'on': 'click'
    });

    $('form[data-confirm]').confirm({
        'on': 'submit'
    });

    $('a[data-method]').click(function(event) {
        event.preventDefault();
        var $this = $(this);
        $this.navigate({
            method: $this.data('method')
        });
    });

    $('.dropdown-toggle').click(function(event) {
        $(this).siblings('.dropdown-container').toggleClass('show');
    });

    var $dropdowns = $('.dropdown-container').parent();
    $(document).click(function (e) {
        e.stopPropagation();
        if ($dropdowns.has(e.target).length === 0) {
            $('.dropdown-container').removeClass('show');
        }
    })
}

})(jQuery);
